module.exports = "/shared/img/fast-btn-down.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/fast-btn-down.png
// module id = 8
// module chunks = 13